import StudyImg from "@assets/images/job/school.png";
import BaseContainer from "@components/ui/BaseContainer";
import BaseLink from "@components/ui/BaseLink";
import { useTranslation } from "react-i18next";

import classes from "./Study.module.scss";

function Study() {
  const { t } = useTranslation();

  return (
    <BaseContainer className={classes.study}>
      <article>
        <img className={classes.study__img} src={StudyImg} alt="" />
      </article>
      <article>
        <p className={classes.study__text}>{t("job.study.text")}</p>
        <BaseLink className={classes.study__link} href={t("job.study.link")}>
          {t("job.study.link-text")}
        </BaseLink>
      </article>
    </BaseContainer>
  );
}

export default Study;
